import { Component, AfterViewInit, Input, ElementRef } from "@angular/core";
import { IPictureData } from "src/app/dynamic-module/lib/public_api";
import { IUProperty } from "src/app/shared/interface/umbraco-property";

export interface ISecurityPanelItemVm {
  header: IUProperty<string>;
  headerColor: IUProperty<string>;
  image: IUProperty<IPictureData>;
  link: IUProperty<string>;
  linkColor: IUProperty<string>;
}

@Component({
  selector: "app-security-panel-item",
  templateUrl: "./security-panel-item.component.html",
  styleUrls: ["./security-panel-item.component.less"],
})
export class SecurityPanelItemComponent implements AfterViewInit {
  @Input() item: ISecurityPanelItemVm;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.item);
  }

  private setCustomThemeProperties(d: ISecurityPanelItemVm) {
    if (d.headerColor && d.headerColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--security-panel-item-header-color",
        d.headerColor.value
      );
    }
  }
}
